import { render, staticRenderFns } from "./SocialAccounts.vue?vue&type=template&id=120d82a0&scoped=true&"
import script from "./SocialAccounts.vue?vue&type=script&lang=js&"
export * from "./SocialAccounts.vue?vue&type=script&lang=js&"
import style0 from "./SocialAccounts.scss?vue&type=style&index=0&id=120d82a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120d82a0",
  null
  
)

export default component.exports